import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const PriceTypeRadioContainer = styled.div`
    padding-bottom: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('600')};
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray100')};
`;

export const PriceTypeTitleContainer = styled.div`
    margin-bottom: ${getPurpurSpacing('300')};
    font-weight: ${getPurpurTypography('weightMedium')};
    color: ${getPurpurColor('brandOffBlack')};
`;
